export const circularGetFromArray = (arr: any[], i: number): any => {
    const n = arr.length
    return arr[(i % n + n) % n]
}